/* eslint-disable  */
import { FavoriteBorderOutlined, ShoppingBasket, Visibility, VisibilityOff } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { FaHandHoldingUsd } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  authActionCreators,
  userDataActionCreators,
} from "../../../../../service/action-creators";
import CidiSymbol from "../../../../CidiSymbol";
import Modal from "../../../../Modal/Modal";

function SectionOne() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [formData, setFormData] = React.useState(null);

  const { ChangePassword } = bindActionCreators(authActionCreators, dispatch);
  const { GetTotalFunds, GetAppliedLoans } = bindActionCreators(
    userDataActionCreators,
    dispatch
  );
  const user = useSelector((state) => state.user);

  const { funds, cart, totalFunds, favoriteProducts, myAppliedLoans, orders } =
    user;

  console.log("totalFunds", totalFunds);
  const [showAmount, setShowAmount] = useState(true);
  const [openComingSoon, setOpenComingSoon] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openRejectedLoan, setRejectedLoan] = React.useState(false);
  const [openRejectedOrder, setRejectedOrder] = React.useState(false);
  const [openLoanRestriction, setOpenLoanRestriction] = React.useState(false);
  const [loanMessage, setLoanMessage] = React.useState("");
  const [loanSelected, setLoanSelected] = React.useState("");
  const [orderSelected, setOrderSelected] = React.useState("");
  const [loanRestrictionMessage, setLoanRestrictionMessage] =
    React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target.value });
  };

  // Function to check if user can apply for a new loan
  const canApplyForLoan = () => {
    // console.log('Checking loan eligibility...');
    // console.log('User object:', user);
    // console.log('myAppliedLoans:', user?.myAppliedLoans);
    // console.log('myAppliedLoans length:', user?.myAppliedLoans?.length);

    if (!user?.myAppliedLoans || user.myAppliedLoans.length === 0) {
      // console.log('No applied loans found - user can apply');
      return { canApply: true, message: "" };
    }

    // Check for loans that are not rejected or paid
    const restrictiveLoan = user.myAppliedLoans.find((loan) => {
      // console.log('Checking loan:', loan);
      // console.log('Loan status:', loan.status);
      return loan.status !== "rejected" && loan.status !== "paid";
    });

    console.log("Restrictive loan found:", restrictiveLoan);

    if (restrictiveLoan) {
      let message = "";

      // Customize message based on current loan status
      switch (restrictiveLoan.status) {
        case "submitted":
          message =
            "You have already submitted a loan application. Please wait for it to be processed.";
          break;
        case "booked":
          message =
            "Your loan application has been booked. Please wait for further processing.";
          break;
        case "initiated":
          message = "Your loan has been initiated. Please wait for completion.";
          break;
        case "authorized":
          message =
            "Your loan has been authorized. Please wait for disbursement.";
          break;
        default:
          message = `You have an active loan application with status: ${restrictiveLoan.status}. Please wait for it to be completed or contact support.`;
      }

      console.log("Blocking loan application with message:", message);
      return {
        canApply: false,
        message: message,
      };
    }

    // User can apply - no restrictive loans found
    console.log("No restrictive loans found - user can apply");
    return { canApply: true, message: "" };
  };

  // Function to check if user can place a new order
  // const canPlaceOrder = () => {
  //   if (!user?.orders || user.orders.length === 0) {
  //     return { canApply: true, message: "" };
  //   }

  //   // Check for orders that are not rejected or completed
  //   const restrictiveOrder = user.orders.find((order) => {
  //     return order.status !== "rejected" && order.status !== "shipped";
  //   });

  //   if (restrictiveOrder) {
  //     let message = `You already have an order with status: ${restrictiveOrder.status}. Please wait for it to complete.`;
  //     return {
  //       canApply: false,
  //       message: message,
  //     };
  //   }

  //   return { canApply: true, message: "" };
  // };

  // Handle loan application click
  const handleLoanApplicationClick = () => {
    const loanCheck = canApplyForLoan();

    if (loanCheck.canApply) {
      history.push("/apply-loan-personal_info");
    } else {
      setLoanRestrictionMessage(loanCheck.message);
      setOpenLoanRestriction(true);
    }
  };

  const handlePlaceOrderClick = () => {
    // const orderCheck = canPlaceOrder();

    // if (orderCheck.canApply) {
    history.push("/upnmg-shopping-mall");
    // } else {
    //   setLoanRestrictionMessage(orderCheck.message);
    //   setOpenLoanRestriction(true);
    // }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (
      (!formData?.confirmPassword || formData?.password !== "",
        !formData?.old_password !== "")
    ) {
      ChangePassword(formData);
      setOpen(false);
    } else {
      toast.error("Make sure to enter new password and confirm password");
    }
    setOpen(false);
  };

  useEffect(() => {
    GetTotalFunds();
    GetAppliedLoans();
  }, []);

  useEffect(() => {
    const loans = user.myAppliedLoans.map((loan) => {
      if (loan?.rejected.length > 0 && loan?.rejected[0].editFormChecked) {
        setRejectedLoan(true);
        setLoanMessage(loan?.rejected[0]?.message);
        setLoanSelected(loan);
      }
    });

    const orderArr = user.orders.map((order) => {
      if (
        order?.rejected.length > 0 &&
        (order?.rejected[0].editFormChecked ||
          order?.rejected[0].editFormAndProductChecked)
      ) {
        setRejectedOrder(true);
        setLoanMessage(order?.rejected[0]?.message);
        setOrderSelected(order);
        console.log("order", order);
      }
    });
  }, [user.myAppliedLoans]);

  const device = () => {
    return window.innerWidth < 1080;
  };
  const [isMobile, setIsMobile] = useState(device);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsMobile(device);
    });
    return 0;
  }, []);

  return (
    <div className="SectionOneMainPageDisplay">
      {/* Contribution Card */}
      <div className="contribCard">
        <div className="contribCard-top">
          <div className="contribCard-label">Total Contributions</div>
          <button className="contribCard-viewBtn" onClick={() => history.push("/fund")}>View</button>
        </div>
        <div className="contribCard-amountRow">
          <span className="contribCard-amount">
            {showAmount
              ? <><CidiSymbol /> {Number(totalFunds).toFixed(2)}</>
              : "• • • • • •"}
          </span>
          <button className="contribCard-eyeBtn" onClick={() => setShowAmount(!showAmount)}>
            {showAmount
              ? <VisibilityOff style={{ fontSize: "1.2rem" }} />
              : <Visibility style={{ fontSize: "1.2rem" }} />}
          </button>
        </div>
        <div className="contribCard-sub">
          {Number(totalFunds) > 0 ? "Great progress this month!" : "Start contributing today!"}
        </div>
      </div>

      {/* Stats Row */}
      <div className="homeStats homeStats--2col">
        <div className="homeStat-card" style={{ cursor: "pointer" }} onClick={() => history.push("/favourites")}>
          <div className="homeStat-icon" style={{ background: "linear-gradient(135deg,#e53935,#b71c1c)" }}>
            <FavoriteBorderOutlined style={{ fontSize: "1.1rem", color: "white" }} />
          </div>
          <div className="homeStat-info">
            <span className="homeStat-label">Favourites</span>
            <span className="homeStat-value">{favoriteProducts?.length ?? 0}</span>
          </div>
        </div>
        <div className="homeStat-card" style={{ cursor: "pointer" }} onClick={() => history.push("/my-cart")}>
          <div className="homeStat-icon" style={{ background: "linear-gradient(135deg,#0067dd,#01325f)" }}>
            <ShoppingBasket style={{ fontSize: "1.1rem", color: "white" }} />
          </div>
          <div className="homeStat-info">
            <span className="homeStat-label">Cart Items</span>
            <span className="homeStat-value">{cart?.length ?? 0}</span>
          </div>
        </div>
      </div>

      {/* Quick Actions Grid */}
      <div className="homeActions-label">Quick Actions</div>
      <div className="homeActions">
        {[
          { img: "/images/shopping-cart.png", label: "UPNMG Mart", sub: "Visit our shop", action: handlePlaceOrderClick },
          { img: "/images/loan.png", label: "Apply Loan", sub: "Apply for loan today", action: handleLoanApplicationClick },
          { img: "/images/profile.png", label: "My Profile", sub: "Edit your profile", action: () => history.push("/profile") },
          { img: "/images/fund-increase.png", label: "Fund", sub: "Increase or decrease", action: () => history.push("/fund-increment") },
          { img: "/images/order-more.png", label: "Orders", sub: "View your orders", action: () => history.push("/my-orders-and-purchase") },
          { img: "/images/applied-loan.png", label: "My Loans", sub: "View applied loans", action: () => history.push("/my-applied-loans") },
          { img: "/images/chat.png", label: "Messenger", sub: "Message UPNMG", action: () => history.push("/message") },
          { img: "/images/grocery-cart.png", label: "My Cart", sub: "Your saved products", action: () => history.push("/my-cart") },
          { img: "/images/favourite.png", label: "Favourites", sub: "Your saved items", action: () => history.push("/favourites") },
          { img: "/images/reset-password.png", label: "Change Password", sub: "Update credentials", action: handleClickOpen },
          { img: "/images/loan-icon.png", label: "Settlement Quotation", sub: "Get a quotation", action: () => setOpenComingSoon(true) },
        ].map((item, i) => (
          <div className="homeAction-card" key={i} onClick={item.action}>
            <div className="homeAction-imgWrap">
              <img src={item.img} alt={item.label} />
            </div>
            <span className="homeAction-label">{item.label}</span>
            <span className="homeAction-sub">{item.sub}</span>
          </div>
        ))}
      </div>

      {/* Change Password Modal */}
      {open && (
        <Modal title={"Change Password"} width={isMobile ? "85%" : "35%"} closeModal={setOpen}>
          <div className="modalBody">
            <div><label htmlFor="old_password">Old Password</label><input type={"password"} placeholder={"Old password"} name="old_password" id="old_password" onChange={handleChange} className="form-control mb-4" /></div>
            <div><label htmlFor="newPassword">New Password</label><input type={"password"} placeholder={"new password"} name="password" id="newPassword" onChange={handleChange} className="form-control mb-4" /></div>
            <div><label htmlFor="confirmPassword">Confirm Password</label><input type={"password"} placeholder={"confirm new password"} name="confirmPassword" id="confirmPassword" onChange={handleChange} className="form-control" /></div>
          </div>
          <div className="modalButton"><div className="btnCover"><button type="button" className="modalBtn" onClick={handleSubmit}>Change</button><button type="button" onClick={() => setOpen(false)} className="cancelBtn">Cancel</button></div></div>
        </Modal>
      )}
      {openLoanRestriction && (
        <Modal title={""} width={isMobile ? "88%" : "34%"} closeModal={setOpenLoanRestriction}>
          <div style={{ textAlign: "center", padding: "0.5rem 0 1rem" }}>
            <div style={{ width: 56, height: 56, borderRadius: "50%", background: "linear-gradient(135deg,#fff3e0,#ffe0b2)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px", fontSize: "1.6rem" }}>⚠️</div>
            <p style={{ fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", marginBottom: 8 }}>Loan Application Restricted</p>
            <p style={{ color: "#666", fontSize: "0.84rem", lineHeight: 1.6 }}>{loanRestrictionMessage}</p>
          </div>
          <div style={{ display: "flex", justifyContent: "center", paddingBottom: "0.5rem" }}>
            <button onClick={() => setOpenLoanRestriction(false)} style={{ background: "linear-gradient(135deg,#01a94b,#015f39)", color: "#fff", border: "none", borderRadius: 50, padding: "10px 32px", fontWeight: 700, fontSize: "0.85rem", cursor: "pointer" }}>OK, Understood</button>
          </div>
        </Modal>
      )}
      {openRejectedLoan && (
        <Modal title={""} width={isMobile ? "88%" : "34%"} closeModal={setRejectedLoan}>
          <div style={{ textAlign: "center", padding: "0.5rem 0 1rem" }}>
            <div style={{ width: 56, height: 56, borderRadius: "50%", background: "linear-gradient(135deg,#ffebee,#ffcdd2)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px", fontSize: "1.6rem" }}>❌</div>
            <p style={{ fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", marginBottom: 8 }}>Loan Application Rejected</p>
            <p style={{ color: "#666", fontSize: "0.84rem", lineHeight: 1.6, marginBottom: 0 }}>{loanSelected?.rejected[0]?.message}</p>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "center", paddingBottom: "0.5rem" }}>
            <button onClick={() => history.push({ pathname: "/edit-loan-form", state: { loan_id: loanSelected?._id } })} style={{ background: "linear-gradient(135deg,#01a94b,#015f39)", color: "#fff", border: "none", borderRadius: 50, padding: "10px 24px", fontWeight: 700, fontSize: "0.85rem", cursor: "pointer" }}>Edit Loan Form</button>
            <button onClick={() => setRejectedLoan(false)} style={{ background: "#f3f4f6", color: "#555", border: "none", borderRadius: 50, padding: "10px 24px", fontWeight: 600, fontSize: "0.85rem", cursor: "pointer" }}>Close</button>
          </div>
        </Modal>
      )}
      {openComingSoon && (
        <Modal title={""} width={isMobile ? "88%" : "32%"} closeModal={setOpenComingSoon}>
          <div style={{ textAlign: "center", padding: "0.5rem 0 1rem" }}>
            <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg,#e8f5e9,#c8e6c9)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: "1.8rem" }}>🚀</div>
            <p style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", marginBottom: 8 }}>Coming Soon</p>
            <p style={{ color: "#888", fontSize: "0.84rem", lineHeight: 1.6 }}>
              <strong style={{ color: "#01a94b" }}>Settlement Quotation</strong> is currently in development.<br />This feature will be available soon. Stay tuned!
            </p>
          </div>
          <div style={{ display: "flex", justifyContent: "center", paddingBottom: "0.5rem" }}>
            <button onClick={() => setOpenComingSoon(false)} style={{ background: "linear-gradient(135deg,#01a94b,#015f39)", color: "#fff", border: "none", borderRadius: 50, padding: "10px 36px", fontWeight: 700, fontSize: "0.85rem", cursor: "pointer" }}>OK, Got it</button>
          </div>
        </Modal>
      )}
      {openRejectedOrder && (
        <Modal title={""} width={isMobile ? "88%" : "34%"} closeModal={setRejectedOrder}>
          <div style={{ textAlign: "center", padding: "0.5rem 0 1rem" }}>
            <div style={{ width: 56, height: 56, borderRadius: "50%", background: "linear-gradient(135deg,#ffebee,#ffcdd2)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px", fontSize: "1.6rem" }}>❌</div>
            <p style={{ fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", marginBottom: 8 }}>Order Application Rejected</p>
            <p style={{ color: "#666", fontSize: "0.84rem", lineHeight: 1.6, marginBottom: 0 }}>{orderSelected?.rejected[0]?.message}</p>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "center", paddingBottom: "0.5rem" }}>
            <button onClick={() => history.push({ pathname: "/edit-order-form", search: `?order_id=${orderSelected?._id}` })} style={{ background: "linear-gradient(135deg,#01a94b,#015f39)", color: "#fff", border: "none", borderRadius: 50, padding: "10px 24px", fontWeight: 700, fontSize: "0.85rem", cursor: "pointer" }}>Edit Mart Form</button>
            <button onClick={() => setRejectedOrder(false)} style={{ background: "#f3f4f6", color: "#555", border: "none", borderRadius: 50, padding: "10px 24px", fontWeight: 600, fontSize: "0.85rem", cursor: "pointer" }}>Close</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default SectionOne;
